// ═══ GOLDENEGG — Main JS ═══

// Scroll Reveal
const obs = new IntersectionObserver(e => e.forEach(x => {
  if (x.isIntersecting) x.target.classList.add('v');
}), { threshold: 0.1 });
document.querySelectorAll('.rv').forEach(el => obs.observe(el));

// Navbar scroll
window.addEventListener('scroll', () => {
  const nav = document.getElementById('navbar');
  if (nav) nav.classList.toggle('sc', scrollY > 30);
});

// Counter animation
function animateCounters() {
  document.querySelectorAll('[data-count]').forEach(el => {
    const target = parseInt(el.dataset.count);
    const duration = 2000;
    const start = performance.now();
    function update(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target).toLocaleString() + '+';
      if (progress < 1) requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  });
}
const counterObs = new IntersectionObserver(e => e.forEach(x => {
  if (x.isIntersecting) { animateCounters(); counterObs.disconnect(); }
}), { threshold: 0.5 });
document.querySelectorAll('.proof-bar').forEach(el => counterObs.observe(el));

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    e.preventDefault();
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      closeMob();
    }
  });
});

// Mobile menu
function closeMob() {
  const menu = document.getElementById('mobileMenu');
  if (menu) menu.classList.remove('open');
}
const mobileToggle = document.getElementById('mobileToggle');
if (mobileToggle) {
  mobileToggle.addEventListener('click', () => {
    const menu = document.getElementById('mobileMenu');
    if (menu) menu.classList.toggle('open');
  });
}
